import { z } from "zod";
import { Area } from "./stuff.ts";

/**
 * Admins' changes to the map callouts (Valve's place names): rename, move the
 * label, set the area, hide, or add a callout of 69LY's own with a drawn box.
 * Applied by @69ly/maps (callouts()).
 */
const frac = z.number().min(0).max(1);

export const CalloutBox = z
  .object({ u0: frac, v0: frac, u1: frac, v1: frac })
  .refine((b) => b.u1 - b.u0 >= 0.004 && b.v1 - b.v0 >= 0.004, "Draw a bigger box.");

export const CalloutEditInput = z
  .object({
    level: z.enum(["upper", "lower"]),
    /** Valve's place name for a change to one of its labels; null for a callout of our own. */
    base: z.string().trim().min(1).max(40).nullable(),
    ordinal: z.number().int().min(0).max(20),
    name: z.string().trim().min(1, "Name the callout.").max(40),
    u: frac,
    v: frac,
    area: Area.nullable(),
    hidden: z.boolean(),
    zone: CalloutBox.nullable(),
  })
  .refine((e) => e.base !== null || e.zone !== null, { message: "A new callout needs a box on the map.", path: ["zone"] });
export type CalloutEditInput = z.infer<typeof CalloutEditInput>;

/** At most this many changes per map. */
export const MAX_CALLOUT_EDITS = 300;

/** Every change on one map, saved together from the admin page. */
export const MapCalloutsInput = z.object({ edits: z.array(CalloutEditInput).max(MAX_CALLOUT_EDITS) });

/** The changes for every map, as the app loads them. */
export interface CalloutEdits {
  maps: Record<string, CalloutEditInput[]>;
  /** When an admin last saved, per map. */
  updatedAt: Record<string, string>;
}
